// Turnstile token verification service
// Calls the verifyTurnstile Cloud Function to validate tokens server-side

const VERIFY_URL = import.meta.env.PROD
  ? 'https://us-central1-supportspace.cloudfunctions.net/verifyTurnstile'
  : 'http://localhost:5001/supportspace/us-central1/verifyTurnstile';

export const verifyTurnstileToken = async (token: string): Promise<boolean> => {
  try {
    const response = await fetch(VERIFY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });
    const result = await response.json();
    return result.success === true;
  } catch (error) {
    console.error('Turnstile verification failed:', error);
    return false;
  }
};
